// @To-Do: Extract to shared library (https://nitrexgroup.atlassian.net/browse/QMU-5093)
export function getUserInitials(firstName: string = '', lastName: string = '') {
  return `${[
    ...firstName,
  ][0] || ''}${[
    ...lastName,
  ][0] || ''}`;
}
